import React, { createContext, useState, useMemo, useEffect } from 'react';

export const ThemeContext = createContext();

// This function is stringified and injected into a <script> tag in index.html
// It runs before React loads to prevent a "flash of unstyled content" (FOUC).
export const setInitialTheme = `
  (function() {
    try {
      const savedTheme = localStorage.getItem('theme');
      if (savedTheme === 'dark') {
        document.body.classList.add('dark');
      }
      // If no theme is saved, we do nothing and let the default light theme apply.
    } catch (e) {
      console.error('Could not set initial theme from localStorage', e);
    }
  })()
`;

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme || 'light';
  });

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  useEffect(() => {
    localStorage.setItem('theme', theme);
    if (theme === 'dark') {
      document.body.classList.add('dark'); // Ensure class is set on toggle
    } else {
      document.body.classList.remove('dark'); // Ensure class is removed on toggle
    }
  }, [theme]);

  const value = useMemo(() => ({ theme, toggleTheme }), [theme]);

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};
